import formComponent from '@/util/proto/formComponent'
import { MiniSku } from './sku'
export default {
  extends: formComponent ,
  data() {
    return {
      formData: {
        code: {
          rules:[
            { required: true, message: '请输入商品编码', trigger: 'blur,change' },
          ]
        },
        name:{
          rules:[
            { required: true, message: '请输入商品名称', trigger: 'blur,change'},
          ]
        },
        categoryId:{
          rules:[
            { required: true, type:'number', message: '请选择商品类型', trigger: 'blur,change'},
          ]
        },
        cashPledgeId: {
          rules:[
            { required: true, type:'number', message: '请选择押金方案', trigger: 'blur,change'},
          ]
        },
        saleMinPrice: { 
          rules: [ { type: 'number', required: true, message: '请输入商品最低单价', trigger: 'blur,change' } ]
        },
        saleMaxPrice: {
          rules:[ { type: 'number', required: true, message: '请输入商品最高单价', trigger: 'blur,change' } ]
        },

        mainImage: {
          rules:[
            { required: false, type:"number", message: '请上传商品主图', trigger: 'blur,change'},
          ]
        },
        slideImage: {
          rules:[
            { required: false, type:"array", message: '请上传商品轮播图', trigger: 'blur,change'},
          ]
        },
        remark:null
        
      },
      id:null,
      loading:false,
      visible:false,
      raw:{},
      api:['goodsCreate','goodsUpdate'],
      state:{
        specs:[],
        specsChecked:[],
        specsOptions:[]
      }
    }
  },
  created(){
    
  },
  computed:{
    title(){
      return this.id ? '修改商品' : '新增商品'
    },
    brands(){
      return this.$request.brands(2).then( resp => {
        return Promise.resolve( resp.data.map(i => ({ value: i.id, label: i.brandShortName })) )
      })
    },
    cates(){
      return this.$request.goodsCate().then(res => res.data.map(i => ({value:i.id, label:i.name})))
    },
    depositPlan(){
      return this.$request.deposits({}).then( resp => {
        return Promise.resolve( resp.data.list.map(i => ({ value: i.id, label: i.schemeName })) )
      })
    },
    action(){
      return this.$request.goodsFileUploadUrl()
    },
   
  },
  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.$resetFormData()
      if (this.id) {
        this.query()
      }
    },

    query(){
      this.loading = true
      this.$request.goods(this.id).then(resp => {
        
        const files = resp.data.files

        resp.data.mainImage = (files.filter(i=>i.isMain)[0] || {id:null}).id
 
        resp.data.slideImage = files.filter(i=>(!i.isMain)).map(({id})=>id)

        if(resp.data.categoryId){
          this.querySpec(resp.data.categoryId)
        }

        this.$setFormData(resp.data)

        this.state.specsChecked = (resp.data.specs || []).map(i=>i.id)

        this.raw = resp.data
        this.loading = false
      })
    },

    querySpec(v){
      this.$request.specifications(v).then(resp=>{
        // console.log( this.$utils.tree( resp.data , 'specType') )
        // console.log(mapSpec( resp.data ))
        this.state.specsOptions = resp.data || []

      })
    },
    onCateChange(v){
      if(v) this.querySpec(v)
    },

    beforeSave(d){
      let { mainImage ,slideImage,...params } = d

      let goodsId = this.id;
      let files = (slideImage || []).map(id=>({id, isMain:0 , goodsId}))

      if(mainImage){
        files.push({
          id:mainImage, isMain:1 , goodsId
        })
      }

      if( params.categoryId ){
        params.specs = this.state.specs.map(i => ({...i, categoryId: params.categoryId}))
      }
      params.files = files

      if(this.id){
        params.id = this.id
      }
      
      return params
    }
    ,
    onSpecChange(v){
      console.log('>>',v)
      this.state.specs = v.map(i=>({
        id:i.id , 
        specName:i.specName,
        specType:i.specType,
        specKey:i.specKey,
        specVal:i.specVal
      }))
    },
  },

  render(){
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title={this.title}>
        <sl-form label-width={100}>
          <sl-form-item label="商品编码">
            <Input v-decorator={this.formData.code}></Input>
          </sl-form-item>
          <sl-form-item label="商品名称">
            <Input v-decorator={this.formData.name}></Input>
          </sl-form-item>
          <sl-form-item label="商品类型">
            <sl-select v-decorator={this.formData.categoryId} dict={this.cates} on-change={this.onCateChange} />
          </sl-form-item>
          <sl-form-item label="押金方案">
            <sl-select v-decorator={this.formData.cashPledgeId} dict={this.depositPlan} />
          </sl-form-item>
          <sl-form-item label="最低售价">
            <InputNumber min={0.01} precision={2} v-decorator={this.formData.saleMinPrice}  />
          </sl-form-item>
          <sl-form-item label="最高售价">
            <InputNumber min={0.01} precision={2} v-decorator={this.formData.saleMaxPrice}  />
          </sl-form-item>
          <sl-form-item label="商品主图">
            <sl-upload action={this.action} getId={(d) => d.id}  preview-url="goodsFile" limit={1} style="margin-top:8px;" v-decorator={this.formData.mainImage} >支持格式：jpg, png, bmp , gif。</sl-upload>
          </sl-form-item>
          <sl-form-item label="商品图片">
            <sl-upload  action={this.action}  getId={(d) => d.id} preview-url="goodsFile" limit={5} style="margin-top:8px;" v-decorator={this.formData.slideImage}>支持格式：jpg, png, bmp , gif。</sl-upload>
          </sl-form-item>
          <sl-form-item label="备注">
            <Input type="textarea" autosize={{minRows: 5,maxRows: 8}} v-decorator={this.formData.remark}></Input>
          </sl-form-item>

        </sl-form>
        
        {
            this.state.specsOptions && this.state.specsOptions.length>0 ? [
              <Divider orientation="left">商品规格</Divider>,
              <sl-checkbox data={this.state.specsOptions} checked-keys={this.state.specsChecked} on-change={this.onSpecChange} field-key="id" field-code="specVal" field-text="specKey" group-name="specName" group-by="specType"></sl-checkbox>
            ] :null
        }
        
        <template slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </template>
      </sl-side-panel>
    )
  }
}

export const View = {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      visible: false,
      specs:[]
    }
  },
  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.goods(this.id).then( resp => {
        this.loading = false
        if(resp.code == 0){
           this.data = resp.data //this.$utils.conv(resp.data,{'districtCode:districtName':'district'})
           this.data.mainImg = resp.data.files.find(i => i.isMain)?.filePath
           this.data.imgs = resp.data.files.filter(i => !i.isMain).map(i => i.filePath)
        }else{
          this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data } = this
    console.log(data,'<<<')
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title="商品详情" loading={loading}>
        <Tabs value="t1">
          <TabPane label="基本信息" name="t1">
            <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
              <sl-detail-list-item title="商品编码">{data.code}</sl-detail-list-item>
              <sl-detail-list-item title="商品名称">{data.name}</sl-detail-list-item>
              <sl-detail-list-item title="商品类型">{data.categoryName}</sl-detail-list-item>
              <sl-detail-list-item title="押金方案">{data.categoryName}</sl-detail-list-item>
              <sl-detail-list-item title="最低售价">{data.saleMinPrice}</sl-detail-list-item>
              <sl-detail-list-item title="最高售价">{data.saleMaxPrice}</sl-detail-list-item>
              <sl-detail-list-item title="主图">
                <sl-img width="90px" height="90px" public={true} src={data.mainImg} />
              </sl-detail-list-item>
              <sl-detail-list-item title="商品图">
                 <sl-carousel images={data.imgs} />
              </sl-detail-list-item>

              <sl-detail-list-item title="备注">{data.remark}</sl-detail-list-item>
            </sl-detail-list> 
          </TabPane>
          <TabPane label="SKU" name="t2">
            <MiniSku records={data.goodsSkus}></MiniSku>
          </TabPane>
        </Tabs>
      </sl-side-panel>
    )
  }
}